import React from 'react'
import { motion } from "framer-motion";
import foundation from '../../image/contact/foundation.png'
import Heading from '../Heading';
const Foundation = () => {
      const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
                duration: 0.8
            }
        }
    };
  return (
     <motion.section
  className="main-lwbl bg-[#F9FAFB] pt-16 pb-16 px-2 overflow-hidden"
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true, margin: "-50px" }}
  variants={containerVariants}
>
  <Heading
    subHeading={"Foundation Information"}
    heading={"Lightweave Beacon Legacy"}
    detail={
      "Lightweave Beacon Legacy is committed to fostering creativity through structured challenges, education, grants, and community support. Our team operates with transparency, integrity, and a deep respect for artists and their work."
    }
  />

  <div className="flex justify-center items-center w-full mt-8">
    <img
      src={foundation}
      alt="Foundation"
      className="w-full max-w-[1000px] object-contain"
    />
  </div>
</motion.section>

  )
}

export default Foundation
